import {Component, Input, OnInit} from '@angular/core';
import {CurrencyPipe, NgIf} from "@angular/common";
import {RouterLink} from "@angular/router";
import {TranslatePipe} from "@ngx-translate/core";

@Component({
  selector: 'app-payment-result',
  standalone: true,
    imports: [
        NgIf,
        RouterLink,
        TranslatePipe,
        CurrencyPipe
    ],
  templateUrl: './result.component.html',
  styleUrl: './result.component.scss'
})
export class ResultComponent implements OnInit{

    @Input() progressType!: 'creditPayment' | 'subscriptionPayment';
    @Input() processState!: 'success' | 'error';
    @Input() totalAmount!: number;

    isCredit: boolean = false;

    ngOnInit() {

        this.isCredit = this.progressType==='creditPayment';

    }
}
